module.exports = __webpack_public_path__ + "static/media/UserDog.d79beb46.png";